'use strict'

import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js'
import { html } from '@polymer/polymer/lib/utils/html-tag.js'

Polymer({
  is: 'moskito-search',
  _template: html`
<style>
 a {
            display: block;
            color: inherit;
            text-decoration: inherit;
            outline: 0;
          }
</style>
<iron-ajax
  url="[[url]]"
  auto
  debounce-duration="300"
  last-response="{{results}}"
  params="[[params]]"
  >
</iron-ajax>
<paper-input id="search" placeholder="[[placeholder]]" value="{{query}}">
  <iron-icon icon="icons:search" slot="suffix"></iron-icon>
</paper-input>
<paper-listbox>
  <template is="dom-repeat" items="[[results.data]]">
    <a href="/songs/[[item.attributes.legacy_id]]">
      <paper-item>
        <paper-ripple></paper-ripple>
        <paper-item-body two-line>
          <div>
            <slot name="main">
              [[item.attributes.title.display.main]]
            </slot>
          </div>
          <div secondary>
            <slot name="secondary">
              <template is="dom-repeat" items="[[item.attributes.authors]]" as="author">
                [[author.name]]
              </template>
            </slot>
          </div>
        </paper-item-body>
      </paper-item>
    </a>
  </template>
  <template is="dom-if" if="[[showMore]]">
    <a href="/songs">
      <paper-button>Voir plus de résultats</paper-button>
    </a>
  </template>
</paper-listbx>
`,
  properties: {
    /**
     * Url to search against
     */
    url: {
      type: String
    },
    /**
     * The text of the query (=searched text)
     */
    query: {
      type: String,
      observer: '_queryObserver'
    },
    /**
     * The parameters of the query
     */
    params: {
      type: Object
    },
    /**
     * The results of the query
     */
    results: {
      type: Array,
      observer: '_resultsObserver'
    },
    /**
     * Placeholder text
     */
    placeholder: {
      type: String
    },
    /**
     * The number of records to be fetched
     * Default : 10
     */
    limit: {
      type: Number,
      value: 10
    },
    /**
     * Whether a link to songs page should be shown at the bottom
     */
    showMore: {
      type: Boolean
    }
  },
  _queryObserver: function (query, _oldQuery) {
    this.set('params', { s: query, 'fields[]': ['legacy_id', 'title', 'authors', 'url'], limit: this.limit })
  },
  _resultsObserver: function (results) {
    this.set('showMore', results.data.length > 0)
  }
})
